/* tslint:disable:max-line-length */
export const material = [
    '3d_rotation',
    'accessibility',
    'accessibility_new',
    'accessible',
    'accessible_forward',
    'account_balance',
    'account_balance_wallet',
    'account_box',
    'account_circle',
    'add_shopping_cart',
    'add_task',
    'addchart',
    'admin_panel_settings',
    'alarm',
    'alarm_add',
    'alarm_off',
    'alarm_on',
    'all_inbox',
    'all_out',
    'analytics',
    'anchor',
    'android',
    'announcement',
    'api',
    'app_blocking',
    'arrow_circle_down',
    'arrow_circle_up',
    'arrow_right_alt',
    'article',
    'aspect_ratio',
    'assessment',
    'assignment',
    'assignment_ind',
    'assignment_late',
    'assignment_return',
    'assignment_returned',
    'assignment_turned_in',
    'autorenew',
    'backup',
    'backup_table',
    'batch_prediction',
    'book',
    'book_online',
    'bookmark',
    'bookmark_border',
    'bookmarks',
    'bug_report',
    'build',
    'build_circle',
    'cached',
    'calendar_today',
    'calendar_view_day',
    'camera_enhance',
    'cancel_schedule_send',
    'card_giftcard',
    'card_membership',
    'card_travel',
    'change_history',
    'check_circle',
    'check_circle_outline',
    'chrome_reader_mode',
    'class',
    'close_fullscreen',
    'code',
    'comment_bank',
    'commute',
    'compare_arrows',
    'contact_page',
    'contact_support',
    'contactless',
    'copyright',
    'credit_card',
    'dashboard',
    'date_range',
    'delete',
    'delete_forever',
    'delete_outline',
    'description',
    'disabled_by_default',
    'dns',
    'done',
    'done_all',
    'done_outline',
    'donut_large',
    'donut_small',
    'drag_indicator',
    'dynamic_form',
    'eco',
    'eject',
    'euro_symbol',
    'event',
    'event_seat',
    'exit_to_app',
    'explore',
    'explore_off',
    'extension',
    'face',
    'fact_check',
    'favorite',
    'favorite_border',
    'feedback',
    'filter_alt',
    'find_in_page',
    'find_replace',
    'fingerprint',
    'flaky',
    'flight_land',
    'flight_takeoff',
    'flip_to_back',
    'flip_to_front',
    'g_translate',
    'gavel',
    'get_app',
    'gif',
    'grade',
    'grading',
    'group_work',
    'help',
    'help_center',
    'help_outline',
    'highlight_alt',
    'highlight_off',
    'history',
    'history_toggle_off',
    'home',
    'horizontal_split',
    'hourglass_disabled',
    'hourglass_empty',
    'hourglass_full',
    'http',
    'https',
    'important_devices',
    'info',
    'input',
    'integration_instructions',
    'invert_colors',
    'label',
    'label_important',
    'label_off',
    'language',
    'launch',
    'leaderboard',
    'line_style',
    'line_weight',
    'list',
    'lock',
    'lock_open',
    'login',
    'loyalty',
    'markunread_mailbox',
    'maximize',
    'mediation',
    'minimize',
    'model_training',
    'next_plan',
    'not_accessible',
    'not_started',
    'note_add',
    'offline_bolt',
    'offline_pin',
    'online_prediction',
    'opacity',
    'open_in_browser',
    'open_in_full',
    'open_in_new',
    'open_with',
    'outbond',
    'outlet',
    'pageview',
    'pan_tool',
    'payment',
    'pending',
    'pending_actions',
    'perm_camera_mic',
    'perm_contact_calendar',
    'perm_data_setting',
    'perm_device_information',
    'perm_identity',
    'perm_media',
    'perm_phone_msg',
    'perm_scan_wifi',
    'pets',
    'picture_in_picture',
    'picture_in_picture_alt',
    'plagiarism',
    'play_for_work',
    'polymer',
    'power_settings_new',
    'pregnant_woman',
    'preview',
    'print',
    'privacy_tip',
    'published_with_changes',
    'query_builder',
    'question_answer',
    'quickreply',
    'receipt',
    'record_voice_over',
    'redeem',
    'remove_shopping_cart',
    'reorder',
    'report_problem',
    'request_page',
    'restore',
    'restore_from_trash',
    'restore_page',
    'room',
    'rounded_corner',
    'rowing',
    'rule',
    'schedule',
    'search',
    'search_off',
    'settings',
    'settings_applications',
    'settings_backup_restore',
    'settings_bluetooth',
    'settings_brightness',
    'settings_cell',
    'settings_ethernet',
    'settings_input_antenna',
    'settings_input_component',
    'settings_input_composite',
    'settings_input_hdmi',
    'settings_input_svideo',
    'settings_overscan',
    'settings_phone',
    'settings_power',
    'settings_remote',
    'settings_voice',
    'shop',
    'shop_two',
    'shopping_bag',
    'shopping_basket',
    'shopping_cart',
    'smart_button',
    'source',
    'speaker_notes',
    'speaker_notes_off',
    'spellcheck',
    'star_rate',
    'stars',
    'sticky_note_2',
    'store',
    'subject',
    'subtitles_off',
    'supervised_user_circle',
    'supervisor_account',
    'support',
    'swap_horiz',
    'swap_horizontal_circle',
    'swap_vert',
    'swap_vertical_circle',
    'sync_alt',
    'system_update_alt',
    'tab',
    'tab_unselected',
    'table_view',
    'text_rotate_up',
    'text_rotate_vertical',
    'text_rotation_angledown',
    'text_rotation_angleup',
    'text_rotation_down',
    'text_rotation_none',
    'theaters',
    'thumb_down',
    'thumb_up',
    'thumbs_up_down',
    'timeline',
    'toc',
    'today',
    'toll',
    'touch_app',
    'tour',
    'track_changes',
    'translate',
    'trending_down',
    'trending_flat',
    'trending_up',
    'turned_in',
    'turned_in_not',
    'unpublished',
    'update',
    'upgrade',
    'verified',
    'verified_user',
    'vertical_split',
    'view_agenda',
    'view_array',
    'view_carousel',
    'view_column',
    'view_day',
    'view_headline',
    'view_list',
    'view_module',
    'view_quilt',
    'view_sidebar',
    'view_stream',
    'view_week',
    'visibility',
    'visibility_off',
    'voice_over_off',
    'watch_later',
    'wifi_protected_setup',
    'work',
    'work_off',
    'work_outline',
    'wysiwyg',
    'youtube_searched_for',
    'zoom_in',
    'zoom_out',
    'add_alert',
    'auto_delete',
    'error',
    'error_outline',
    'notification_important',
    'warning',
    '4k',
    '5g',
    'add_to_queue',
    'airplay',
    'album',
    'art_track',
    'av_timer',
    'branding_watermark',
    'call_to_action',
    'closed_caption',
    'closed_caption_disabled',
    'control_camera',
    'equalizer',
    'explicit',
    'fast_forward',
    'fast_rewind',
    'featured_play_list',
    'featured_video',
    'fiber_dvr',
    'fiber_manual_record',
    'fiber_new',
    'fiber_pin',
    'fiber_smart_record',
    'forward_10',
    'forward_30',
    'forward_5',
    'games',
    'hd',
    'hearing',
    'hearing_disabled',
    'high_quality',
    'library_add',
    'library_add_check',
    'library_books',
    'library_music',
    'loop',
    'mic',
    'mic_none',
    'mic_off',
    'missed_video_call',
    'movie',
    'music_video',
    'new_releases',
    'not_interested',
    'note',
    'pause',
    'pause_circle_filled',
    'pause_circle_outline',
    'play_arrow',
    'play_circle_filled',
    'play_circle_outline',
    'playlist_add',
    'playlist_add_check',
    'playlist_play',
    'queue',
    'queue_music',
    'queue_play_next',
    'radio',
    'recent_actors',
    'remove_from_queue',
    'repeat',
    'repeat_one',
    'replay',
    'replay_10',
    'replay_30',
    'replay_5',
    'shuffle',
    'skip_next',
    'skip_previous',
    'slow_motion_video',
    'snooze',
    'sort_by_alpha',
    'speed',
    'stop',
    'stop_circle',
    'subscriptions',
    'subtitles',
    'surround_sound',
    'video_call',
    'video_label',
    'video_library',
    'video_settings',
    'videocam',
    'videocam_off',
    'volume_down',
    'volume_mute',
    'volume_off',
    'volume_up',
    'web',
    'web_asset',
    'add_ic_call',
    'alternate_email',
    'business',
    'call',
    'call_end',
    'call_made',
    'call_merge',
    'call_missed',
    'call_missed_outgoing',
    'call_received',
    'call_split',
    'cancel_presentation',
    'chat',
    'chat_bubble',
    'chat_bubble_outline',
    'clear_all',
    'comment',
    'contact_mail',
    'contact_phone',
    'contacts',
    'desktop_access_disabled',
    'dialer_sip',
    'dialpad',
    'domain_disabled',
    'domain_verification',
    'duo',
    'email',
    'forum',
    'forward_to_inbox',
    'hourglass_bottom',
    'hourglass_top',
    'import_contacts',
    'import_export',
    'invert_colors_off',
    'list_alt',
    'live_help',
    'location_off',
    'location_on',
    'mail_outline',
    'mark_chat_read',
    'mark_chat_unread',
    'mark_email_read',
    'mark_email_unread',
    'message',
    'mobile_screen_share',
    'more_time',
    'nat',
    'no_sim',
    'pause_presentation',
    'person_add_disabled',
    'person_search',
    'phone',
    'phone_disabled',
    'phone_enabled',
    'phonelink_erase',
    'phonelink_lock',
    'phonelink_ring',
    'phonelink_setup',
    'portable_wifi_off',
    'present_to_all',
    'print_disabled',
    'qr_code',
    'qr_code_scanner',
    'read_more',
    'ring_volume',
    'rss_feed',
    'screen_share',
    'sentiment_satisfied_alt',
    'speaker_phone',
    'stay_current_landscape',
    'stay_current_portrait',
    'stay_primary_landscape',
    'stay_primary_portrait',
    'stop_screen_share',
    'swap_calls',
    'textsms',
    'unsubscribe',
    'voicemail',
    'vpn_key',
    'wifi_calling',
    'add',
    'add_box',
    'add_circle',
    'add_circle_outline',
    'amp_stories',
    'archive',
    'backspace',
    'ballot',
    'biotech',
    'block',
    'calculate',
    'clear',
    'content_copy',
    'content_cut',
    'content_paste',
    'create',
    'delete_sweep',
    'drafts',
    'dynamic_feed',
    'file_copy',
    'filter_list',
    'flag',
    'font_download',
    'forward',
    'gesture',
    'how_to_reg',
    'how_to_vote',
    'inbox',
    'insights',
    'link',
    'link_off',
    'low_priority',
    'mail',
    'markunread',
    'move_to_inbox',
    'next_week',
    'outlined_flag',
    'policy',
    'push_pin',
    'redo',
    'remove',
    'remove_circle',
    'remove_circle_outline',
    'reply',
    'reply_all',
    'report',
    'report_off',
    'save',
    'save_alt',
    'select_all',
    'send',
    'sort',
    'square_foot',
    'text_format',
    'unarchive',
    'undo',
    'waves',
    'weekend',
    'where_to_vote',
    'access_alarm',
    'access_alarms',
    'access_time',
    'ad_units',
    'add_alarm',
    'add_to_home_screen',
    'airplanemode_active',
    'airplanemode_inactive',
    'battery_alert',
    'battery_charging_full',
    'battery_full',
    'battery_std',
    'battery_unknown',
    'bluetooth',
    'bluetooth_connected',
    'bluetooth_disabled',
    'bluetooth_searching',
    'brightness_auto',
    'brightness_high',
    'brightness_low',
    'brightness_medium',
    'data_usage',
    'developer_mode',
    'devices',
    'dvr',
    'gps_fixed',
    'gps_not_fixed',
    'gps_off',
    'graphic_eq',
    'location_disabled',
    'location_searching',
    'mobile_friendly',
    'mobile_off',
    'nfc',
    'screen_lock_landscape',
    'screen_lock_portrait',
    'screen_lock_rotation',
    'screen_rotation',
    'sd_storage',
    'settings_system_daydream',
    'signal_cellular_4_bar',
    'signal_cellular_alt',
    'signal_cellular_connected_no_internet_4_bar',
    'signal_cellular_no_sim',
    'signal_cellular_null',
    'signal_cellular_off',
    'signal_wifi_4_bar',
    'signal_wifi_4_bar_lock',
    'signal_wifi_off',
    'storage',
    'usb',
    'wallpaper',
    'widgets',
    'wifi_lock',
    'wifi_tethering',
    'add_comment',
    'attach_file',
    'attach_money',
    'bar_chart',
    'border_all',
    'border_bottom',
    'border_clear',
    'border_horizontal',
    'border_inner',
    'border_left',
    'border_outer',
    'border_right',
    'border_style',
    'border_top',
    'border_vertical',
    'bubble_chart',
    'drag_handle',
    'format_align_center',
    'format_align_justify',
    'format_align_left',
    'format_align_right',
    'format_bold',
    'format_clear',
    'format_color_reset',
    'format_indent_decrease',
    'format_indent_increase',
    'format_italic',
    'format_line_spacing',
    'format_list_bulleted',
    'format_list_numbered',
    'format_list_numbered_rtl',
    'format_paint',
    'format_quote',
    'format_shapes',
    'format_size',
    'format_strikethrough',
    'format_textdirection_l_to_r',
    'format_textdirection_r_to_l',
    'format_underlined',
    'functions',
    'height',
    'highlight',
    'horizontal_rule',
    'insert_chart',
    'insert_chart_outlined',
    'insert_comment',
    'insert_drive_file',
    'insert_emoticon',
    'insert_invitation',
    'insert_link',
    'insert_photo',
    'linear_scale',
    'merge_type',
    'mode_comment',
    'monetization_on',
    'money_off',
    'multiline_chart',
    'notes',
    'pie_chart',
    'post_add',
    'publish',
    'scatter_plot',
    'score',
    'short_text',
    'show_chart',
    'space_bar',
    'stacked_line_chart',
    'strikethrough_s',
    'subscript',
    'superscript',
    'table_chart',
    'table_rows',
    'text_fields',
    'title',
    'vertical_align_bottom',
    'vertical_align_center',
    'vertical_align_top',
    'wrap_text',
    'attach_email',
    'attachment',
    'cloud',
    'cloud_circle',
    'cloud_done',
    'cloud_download',
    'cloud_off',
    'cloud_queue',
    'cloud_upload',
    'create_new_folder',
    'folder',
    'folder_open',
    'folder_shared',
    'request_quote',
    'rule_folder',
    'snippet_folder',
    'text_snippet',
    'topic',
    'browser_not_supported',
    'cast',
    'cast_connected',
    'cast_for_education',
    'computer',
    'desktop_mac',
    'desktop_windows',
    'developer_board',
    'device_hub',
    'device_unknown',
    'devices_other',
    'dock',
    'gamepad',
    'headset',
    'headset_mic',
    'keyboard',
    'keyboard_arrow_down',
    'keyboard_arrow_left',
    'keyboard_arrow_right',
    'keyboard_arrow_up',
    'keyboard_backspace',
    'keyboard_capslock',
    'keyboard_hide',
    'keyboard_return',
    'keyboard_tab',
    'keyboard_voice',
    'laptop',
    'laptop_chromebook',
    'laptop_mac',
    'laptop_windows',
    'memory',
    'mouse',
    'phone_android',
    'phone_iphone',
    'phonelink',
    'phonelink_off',
    'point_of_sale',
    'power_input',
    'router',
    'scanner',
    'security',
    'sim_card',
    'smartphone',
    'speaker',
    'speaker_group',
    'tablet',
    'tablet_android',
    'tablet_mac',
    'toys',
    'tv',
    'videogame_asset',
    'watch',
    'sensor_door',
    'sensor_window',
    'add_a_photo',
    'add_photo_alternate',
    'add_to_photos',
    'adjust',
    'assistant',
    'assistant_photo',
    'audiotrack',
    'bedtime',
    'blur_circular',
    'blur_linear',
    'blur_off',
    'blur_on',
    'brightness_1',
    'brightness_2',
    'brightness_3',
    'brightness_4',
    'brightness_5',
    'brightness_6',
    'brightness_7',
    'broken_image',
    'brush',
    'burst_mode',
    'camera',
    'camera_alt',
    'camera_front',
    'camera_rear',
    'camera_roll',
    'center_focus_strong',
    'center_focus_weak',
    'collections',
    'collections_bookmark',
    'color_lens',
    'colorize',
    'compare',
    'control_point',
    'control_point_duplicate',
    'crop',
    'crop_16_9',
    'crop_3_2',
    'crop_5_4',
    'crop_7_5',
    'crop_din',
    'crop_free',
    'crop_landscape',
    'crop_original',
    'crop_portrait',
    'crop_rotate',
    'crop_square',
    'dehaze',
    'details',
    'edit',
    'euro',
    'exposure',
    'exposure_neg_1',
    'exposure_neg_2',
    'exposure_plus_1',
    'exposure_plus_2',
    'exposure_zero',
    'filter',
    'filter_1',
    'filter_2',
    'filter_3',
    'filter_4',
    'filter_5',
    'filter_6',
    'filter_7',
    'filter_8',
    'filter_9',
    'filter_9_plus',
    'filter_b_and_w',
    'filter_center_focus',
    'filter_drama',
    'filter_frames',
    'filter_hdr',
    'filter_none',
    'filter_tilt_shift',
    'filter_vintage',
    'flare',
    'flash_auto',
    'flash_off',
    'flash_on',
    'flip',
    'flip_camera_android',
    'flip_camera_ios',
    'gradient',
    'grain',
    'grid_off',
    'grid_on',
    'hdr_off',
    'hdr_on',
    'hdr_strong',
    'hdr_weak',
    'healing',
    'image',
    'image_aspect_ratio',
    'image_not_supported',
    'image_search',
    'iso',
    'landscape',
    'leak_add',
    'leak_remove',
    'lens',
    'linked_camera',
    'looks',
    'looks_3',
    'looks_4',
    'looks_5',
    'looks_6',
    'looks_one',
    'looks_two',
    'loupe',
    'monochrome_photos',
    'motion_photos_on',
    'motion_photos_pause',
    'motion_photos_paused',
    'movie_creation',
    'movie_filter',
    'music_note',
    'music_off',
    'nature',
    'nature_people',
    'navigate_before',
    'navigate_next',
    'palette',
    'panorama',
    'panorama_fish_eye',
    'panorama_horizontal',
    'panorama_vertical',
    'panorama_wide_angle',
    'photo',
    'photo_album',
    'photo_camera',
    'photo_filter',
    'photo_library',
    'photo_size_select_actual',
    'photo_size_select_large',
    'photo_size_select_small',
    'picture_as_pdf',
    'portrait',
    'receipt_long',
    'remove_red_eye',
    'rotate_90_degrees_ccw',
    'rotate_left',
    'rotate_right',
    'shutter_speed',
    'slideshow',
    'straighten',
    'style',
    'switch_camera',
    'switch_video',
    'tag_faces',
    'texture',
    'timelapse',
    'timer',
    'timer_10',
    'timer_3',
    'timer_off',
    'tonality',
    'transform',
    'tune',
    'view_comfy',
    'view_compact',
    'vignette',
    'wb_auto',
    'wb_cloudy',
    'wb_incandescent',
    'wb_iridescent',
    'wb_sunny',
    '360',
    'add_business',
    'add_location',
    'add_location_alt',
    'add_road',
    'agriculture',
    'alt_route',
    'atm',
    'beenhere',
    'bike_scooter',
    'category',
    'cleaning_services',
    'compass_calibration',
    'departure_board',
    'design_services',
    'directions',
    'directions_bike',
    'directions_boat',
    'directions_bus',
    'directions_car',
    'directions_railway',
    'directions_run',
    'directions_subway',
    'directions_transit',
    'directions_walk',
    'edit_attributes',
    'edit_location',
    'edit_road',
    'electric_bike',
    'electric_car',
    'electric_moped',
    'electric_scooter',
    'electrical_services',
    'ev_station',
    'fastfood',
    'flight',
    'handyman',
    'home_repair_service',
    'hotel',
    'hvac',
    'layers',
    'layers_clear',
    'local_activity',
    'local_airport',
    'local_atm',
    'local_bar',
    'local_cafe',
    'local_car_wash',
    'local_convenience_store',
    'local_dining',
    'local_drink',
    'local_fire_department',
    'local_florist',
    'local_gas_station',
    'local_grocery_store',
    'local_hospital',
    'local_hotel',
    'local_laundry_service',
    'local_library',
    'local_mall',
    'local_movies',
    'local_offer',
    'local_parking',
    'local_pharmacy',
    'local_phone',
    'local_pizza',
    'local_play',
    'local_police',
    'local_post_office',
    'local_printshop',
    'local_see',
    'local_shipping',
    'local_taxi',
    'map',
    'maps_ugc',
    'medical_services',
    'menu_book',
    'miscellaneous_services',
    'money',
    'moped',
    'multiple_stop',
    'museum',
    'my_location',
    'navigation',
    'near_me',
    'near_me_disabled',
    'no_meals',
    'no_transfer',
    'not_listed_location',
    'pedal_bike',
    'person_pin',
    'person_pin_circle',
    'pest_control',
    'pest_control_rodent',
    'pin_drop',
    'place',
    'plumbing',
    'rate_review',
    'restaurant',
    'restaurant_menu',
    'run_circle',
    'satellite',
    'set_meal',
    'store_mall_directory',
    'streetview',
    'subway',
    'terrain',
    'traffic',
    'train',
    'tram',
    'transfer_within_a_station',
    'transit_enterexit',
    'trip_origin',
    'two_wheeler',
    'wine_bar',
    'wrong_location',
    'zoom_out_map',
    'app_settings_alt',
    'apps',
    'arrow_back',
    'arrow_back_ios',
    'arrow_downward',
    'arrow_drop_down',
    'arrow_drop_down_circle',
    'arrow_drop_up',
    'arrow_forward',
    'arrow_forward_ios',
    'arrow_left',
    'arrow_right',
    'arrow_upward',
    'campaign',
    'cancel',
    'check',
    'chevron_left',
    'chevron_right',
    'close',
    'double_arrow',
    'east',
    'expand_less',
    'expand_more',
    'first_page',
    'fullscreen',
    'fullscreen_exit',
    'home_work',
    'last_page',
    'legend_toggle',
    'menu',
    'menu_open',
    'more_horiz',
    'more_vert',
    'north',
    'north_east',
    'north_west',
    'payments',
    'refresh',
    'south',
    'south_east',
    'south_west',
    'subdirectory_arrow_left',
    'subdirectory_arrow_right',
    'switch_left',
    'switch_right',
    'unfold_less',
    'unfold_more',
    'west',
    'account_tree',
    'adb',
    'airline_seat_flat',
    'airline_seat_flat_angled',
    'airline_seat_individual_suite',
    'airline_seat_legroom_extra',
    'airline_seat_legroom_normal',
    'airline_seat_legroom_reduced',
    'airline_seat_recline_extra',
    'airline_seat_recline_normal',
    'bluetooth_audio',
    'confirmation_number',
    'directions_off',
    'disc_full',
    'drive_eta',
    'enhanced_encryption',
    'event_available',
    'event_busy',
    'event_note',
    'folder_special',
    'live_tv',
    'mms',
    'more',
    'network_check',
    'network_locked',
    'no_encryption',
    'ondemand_video',
    'personal_video',
    'phone_bluetooth_speaker',
    'phone_callback',
    'phone_forwarded',
    'phone_in_talk',
    'phone_locked',
    'phone_missed',
    'phone_paused',
    'power',
    'power_off',
    'priority_high',
    'sd_card',
    'sms',
    'sms_failed',
    'support_agent',
    'sync',
    'sync_disabled',
    'sync_problem',
    'system_update',
    'tap_and_play',
    'time_to_leave',
    'tv_off',
    'vibration',
    'voice_chat',
    'vpn_lock',
    'wc',
    'wifi',
    'wifi_off',
    'ac_unit',
    'airport_shuttle',
    'all_inclusive',
    'apartment',
    'baby_changing_station',
    'backpack',
    'bathtub',
    'beach_access',
    'bento',
    'business_center',
    'carpenter',
    'casino',
    'charging_station',
    'checkroom',
    'child_care',
    'child_friendly',
    'corporate_fare',
    'countertops',
    'do_not_step',
    'do_not_touch',
    'dry',
    'elevator',
    'escalator',
    'escalator_warning',
    'family_restroom',
    'fence',
    'fire_extinguisher',
    'fitness_center',
    'food_bank',
    'foundation',
    'free_breakfast',
    'golf_course',
    'grass',
    'hot_tub',
    'house',
    'house_siding',
    'kitchen',
    'meeting_room',
    'microwave',
    'night_shelter',
    'no_backpack',
    'no_cell',
    'no_drinks',
    'no_flash',
    'no_food',
    'no_meeting_room',
    'no_photography',
    'no_stroller',
    'pool',
    'rice_bowl',
    'roofing',
    'room_preferences',
    'room_service',
    'rv_hookup',
    'smoke_free',
    'smoking_rooms',
    'soap',
    'spa',
    'sports_bar',
    'stairs',
    'storefront',
    'stroller',
    'tapas',
    'tty',
    'umbrella',
    'wash',
    'water_damage',
    'wheelchair_pickup',
    '6_ft_apart',
    'architecture',
    'cake',
    'clean_hands',
    'connect_without_contact',
    'construction',
    'coronavirus',
    'deck',
    'domain',
    'elderly',
    'emoji_emotions',
    'emoji_events',
    'emoji_flags',
    'emoji_food_beverage',
    'emoji_nature',
    'emoji_objects',
    'emoji_people',
    'emoji_symbols',
    'emoji_transportation',
    'engineering',
    'facebook',
    'fireplace',
    'follow_the_signs',
    'group',
    'group_add',
    'groups',
    'history_edu',
    'king_bed',
    'leave_bags_at_home',
    'location_city',
    'luggage',
    'masks',
    'military_tech',
    'mood',
    'mood_bad',
    'nights_stay',
    'no_luggage',
    'notifications',
    'notifications_active',
    'notifications_none',
    'notifications_off',
    'notifications_paused',
    'outdoor_grill',
    'pages',
    'party_mode',
    'people',
    'people_alt',
    'people_outline',
    'person',
    'person_add',
    'person_add_alt_1',
    'person_outline',
    'person_remove',
    'person_remove_alt_1',
    'plus_one',
    'poll',
    'psychology',
    'public',
    'public_off',
    'reduce_capacity',
    'sanitizer',
    'school',
    'science',
    'self_improvement',
    'sentiment_dissatisfied',
    'sentiment_satisfied',
    'sentiment_very_dissatisfied',
    'sentiment_very_satisfied',
    'share',
    'sick',
    'single_bed',
    'sports',
    'sports_baseball',
    'sports_basketball',
    'sports_cricket',
    'sports_esports',
    'sports_football',
    'sports_golf',
    'sports_handball',
    'sports_hockey',
    'sports_kabaddi',
    'sports_mma',
    'sports_motorsports',
    'sports_rugby',
    'sports_soccer',
    'sports_tennis',
    'sports_volleyball',
    'thumb_down_alt',
    'thumb_up_alt',
    'whatshot',
    'check_box',
    'check_box_outline_blank',
    'indeterminate_check_box',
    'radio_button_checked',
    'radio_button_unchecked',
    'star',
    'star_border',
    'star_half',
    'star_outline',
    'toggle_off',
    'toggle_on'
];
export const iconsmind = [
    'a_z',
    'aa',
    'add_bag',
    'add_basket',
    'add_cart',
    'add_file',
    'add_spaceafterparagraph',
    'add_spacebeforeparagraph',
    'add_user',
    'add_userstar',
    'add_window',
    'add',
    'address_book',
    'address_book2',
    'administrator',
    'aerobics_2',
    'aerobics_3',
    'aerobics',
    'affiliate',
    'aim',
    'air_balloon',
    'airbrush',
    'airship',
    'alarm_clock',
    'alarm_clock2',
    'alarm',
    'alien_2',
    'alien',
    'aligator',
    'align_center',
    'align_justifyall',
    'align_justifycenter',
    'align_justifyleft',
    'align_justifyright',
    'align_left',
    'align_right',
    'alpha',
    'ambulance',
    'amx',
    'anchor_2',
    'anchor',
    'android_store',
    'android',
    'angel_smiley',
    'angel',
    'angry',
    'apple_bite',
    'apple_store',
    'apple',
    'approved_window',
    'aquarius_2',
    'aquarius',
    'archery_2',
    'archery',
    'argentina',
    'aries_2',
    'aries',
    'army_key',
    'arrow_around',
    'arrow_back',
    'arrow_back2',
    'arrow_back3',
    'arrow_barrier',
    'arrow_circle',
    'arrow_cross',
    'arrow_down',
    'arrow_down2',
    'arrow_down3',
    'arrow_downincircle',
    'arrow_fork',
    'arrow_forward',
    'arrow_forward2',
    'arrow_from',
    'arrow_inside',
    'arrow_inside45',
    'arrow_insidegap',
    'arrow_insidegap45',
    'arrow_into',
    'arrow_join',
    'arrow_junction',
    'arrow_left',
    'arrow_left2',
    'arrow_leftincircle',
    'arrow_loop',
    'arrow_merge',
    'arrow_mix',
    'arrow_next',
    'arrow_outleft',
    'arrow_outright',
    'arrow_outside',
    'arrow_outside45',
    'arrow_outsidegap',
    'arrow_outsidegap45',
    'arrow_over',
    'arrow_refresh',
    'arrow_refresh2',
    'arrow_right',
    'arrow_right2',
    'arrow_rightincircle',
    'arrow_shuffle',
    'arrow_squiggly',
    'arrow_through',
    'arrow_to',
    'arrow_turnleft',
    'arrow_turnright',
    'arrow_up',
    'arrow_up2',
    'arrow_up3',
    'arrow_upincircle',
    'arrow_xleft',
    'arrow_xright',
    'ask',
    'assistant',
    'astronaut',
    'at_sign',
    'atm',
    'atom',
    'audio',
    'auto_flash',
    'autumn',
    'baby_clothes',
    'baby_clothes2',
    'baby_cry',
    'baby',
    'back_media',
    'back_music',
    'back',
    'back2',
    'background',
    'bacteria',
    'bag_coins',
    'bag_items',
    'bag_quantity',
    'bag',
    'bakelite',
    'ballet_shoes',
    'balloon',
    'banana',
    'band_aid',
    'bank',
    'bar_chart',
    'bar_chart2',
    'bar_chart3',
    'bar_chart4',
    'bar_chart5',
    'bar_code',
    'barricade_2',
    'barricade',
    'baseball',
    'basket_ball',
    'basket_coins',
    'basket_items',
    'basket_quantity',
    'bat_2',
    'bat',
    'bathrobe',
    'batman_mask',
    'battery_0',
    'battery_25',
    'battery_50',
    'battery_75',
    'battery_100',
    'battery_charge',
    'bear',
    'beard_2',
    'beard_3',
    'beard',
    'bebo',
    'bee',
    'beer_glass',
    'beer',
    'bell_2',
    'bell',
    'belt_2',
    'belt_3',
    'belt',
    'berlin_tower',
    'beta',
    'betvibes',
    'bicycle_2',
    'bicycle_3',
    'bicycle',
    'big_bang',
    'big_data',
    'bike_helmet',
    'bikini',
    'bilk_bottle2',
    'billing',
    'bing',
    'binocular',
    'bio_hazard',
    'biotech',
    'bird_deliveringletter',
    'bird',
    'birthday_cake',
    'bisexual',
    'bishop',
    'bitcoin',
    'black_cat',
    'blackboard',
    'blinklist',
    'block_cloud',
    'block_window',
    'blogger',
    'blood',
    'blouse',
    'blueprint',
    'board',
    'bodybuilding',
    'bold_text',
    'bone',
    'bones',
    'book',
    'bookmark',
    'books_2',
    'books',
    'boom',
    'boot_2',
    'boot',
    'bottom_totop',
    'bow_2',
    'bow_3',
    'bow_4',
    'bow_5',
    'bow_6',
    'bow',
    'bowling_2',
    'bowling',
    'box_close',
    'box_full',
    'box_open',
    'box_withfolders',
    'box',
    'box2',
    'boy',
    'bra',
    'brain_2',
    'brain_3',
    'brain',
    'brazil',
    'bread_2',
    'bread',
    'bridge',
    'brightkite',
    'broke_link2',
    'broken_link',
    'broom',
    'brush',
    'bucket',
    'bug',
    'building',
    'bulleted_list',
    'bus_2',
    'bus',
    'business_man',
    'business_manwoman',
    'business_mens',
    'business_woman',
    'butterfly',
    'button',
    'cable_car',
    'cake',
    'calculator_2',
    'calculator_3',
    'calculator',
    'calendar_2',
    'calendar_3',
    'calendar_4',
    'calendar_clock',
    'calendar',
    'camel',
    'camera_2',
    'camera_3',
    'camera_4',
    'camera_5',
    'camera_back',
    'camera',
    'can_2',
    'can',
    'canada',
    'cancer_2',
    'cancer_3',
    'cancer',
    'candle',
    'candy_cane',
    'candy',
    'cannon',
    'cap_2',
    'cap_3',
    'cap_smiley',
    'cap',
    'capricorn_2',
    'capricorn',
    'car_2',
    'car_3',
    'car_coins',
    'car_items',
    'car_wheel',
    'car',
    'cardigan',
    'cardiovascular',
    'cart_quantity',
    'casette_tape',
    'cash_register',
    'cash_register2',
    'castle',
    'cat',
    'cathedral',
    'cauldron',
    'cd_2',
    'cd_cover',
    'cd',
    'cello',
    'celsius',
    'chacked_flag',
    'chair',
    'charger',
    'check_2',
    'check',
    'checked_user',
    'checkmate',
    'checkout_bag',
    'checkout_basket',
    'checkout',
    'cheese',
    'cheetah',
    'chef_hat',
    'chef_hat2',
    'chef',
    'chemical_2',
    'chemical_3',
    'chemical_4',
    'chemical_5',
    'chemical',
    'chess_board',
    'chess',
    'chicken',
    'chile',
    'chimney',
    'china',
    'chinese_temple',
    'chip',
    'chopsticks_2',
    'chopsticks',
    'christmas_ball',
    'christmas_bell',
    'christmas_candle',
    'christmas_hat',
    'christmas_sleigh',
    'christmas_snowman',
    'christmas_sock',
    'christmas_tree',
    'christmas',
    'chrome',
    'chrysler_building',
    'cinema',
    'circular_point',
    'city_hall',
    'clamp',
    'clapperboard_close',
    'clapperboard_open',
    'claps',
    'clef',
    'clinic',
    'clock_2',
    'clock_3',
    'clock_4',
    'clock_back',
    'clock_forward',
    'clock',
    'close_window',
    'close',
    'clothing_store',
    'cloud_',
    'cloud_camera',
    'cloud_computer',
    'cloud_email',
    'cloud_hail',
    'cloud_laptop',
    'cloud_lock',
    'cloud_minus',
    'cloud_moon',
    'cloud_music',
    'cloud_picture',
    'cloud_rain',
    'cloud_remove',
    'cloud_secure',
    'cloud_settings',
    'cloud_smartphone',
    'cloud_snow',
    'cloud_sun',
    'cloud_tablet',
    'cloud_video',
    'cloud_weather',
    'cloud',
    'clouds_weather',
    'clouds',
    'clown',
    'cmyk',
    'coat',
    'cocktail',
    'coconut',
    'code_window',
    'coding',
    'coffee_2',
    'coffee_bean',
    'coffee_machine',
    'coffee_togo',
    'coffee',
    'coffin',
    'coin',
    'coins_2',
    'coins_3',
    'coins',
    'colombia',
    'colosseum',
    'column_2',
    'column_3',
    'column',
    'comb_2',
    'comb',
    'communication_tower',
    'communication_tower2',
    'compass_2',
    'compass_3',
    'compass_4',
    'compass_rose',
    'compass',
    'computer_2',
    'computer_3',
    'computer_secure',
    'computer',
    'conference',
    'confused',
    'conservation',
    'consulting',
    'contrast',
    'control_2',
    'control',
    'cookie_man',
    'cookies',
    'cool_guy',
    'cool',
    'copyright',
    'costume',
    'couple_sign',
    'cow',
    'cpu',
    'crane',
    'cranium',
    'credit_card',
    'credit_card2',
    'credit_card3',
    'cricket',
    'criminal',
    'croissant',
    'crop_2',
    'crop_3',
    'crown_2',
    'crown',
    'crying',
    'cube_molecule',
    'cube_molecule2',
    'cupcake',
    'cursor_click',
    'cursor_click2',
    'cursor_move',
    'cursor_move2',
    'cursor_select',
    'cursor',
    'd_eyeglasses',
    'd_eyeglasses2',
    'dam',
    'danemark',
    'danger_2',
    'danger',
    'dashboard',
    'data_backup',
    'data_block',
    'data_center',
    'data_clock',
    'data_cloud',
    'data_compress',
    'data_copy',
    'data_download',
    'data_financial',
    'data_key',
    'data_lock',
    'data_network',
    'data_password',
    'data_power',
    'data_refresh',
    'data_save',
    'data_search',
    'data_security',
    'data_settings',
    'data_sharing',
    'data_shield',
    'data_signal',
    'data_storage',
    'data_stream',
    'data_transfer',
    'data_unlock',
    'data_upload',
    'data_yes',
    'data',
    'david_star',
    'daylight',
    'death',
    'debian',
    'dec',
    'decrase_inedit',
    'deer_2',
    'deer',
    'delete_file',
    'delete_window',
    'delicious',
    'depression',
    'deviantart',
    'device_syncwithcloud',
    'diamond',
    'dice_2',
    'dice',
    'digg',
    'digital_drawing',
    'diigo',
    'dinosaur',
    'diploma_2',
    'diploma',
    'direction_east',
    'direction_north',
    'direction_south',
    'direction_west',
    'director',
    'disk',
    'dj',
    'dna_2',
    'dna_helix',
    'dna',
    'doctor',
    'dog',
    'dollar_sign',
    'dollar_sign2',
    'dollar',
    'dolphin',
    'domino',
    'door_hanger',
    'door',
    'doplr',
    'double_circle',
    'double_tap',
    'doughnut',
    'dove',
    'down_2',
    'down_3',
    'down_4',
    'down',
    'download_2',
    'download_fromcloud',
    'download_window',
    'download',
    'downward',
    'drag_down',
    'drag_left',
    'drag_right',
    'drag_up',
    'drag',
    'dress',
    'drill_2',
    'drill',
    'drop',
    'dropbox',
    'drum',
    'dry',
    'duck',
    'dumbbell',
    'duplicate_layer',
    'duplicate_window',
    'dvd',
    'eagle',
    'ear',
    'earphones_2',
    'earphones',
    'eci_icon',
    'edit_map',
    'edit',
    'eggs',
    'egypt',
    'eifel_tower',
    'eject_2',
    'eject',
    'el_castillo',
    'elbow',
    'electric_guitar',
    'electricity',
    'elephant',
    'email',
    'embassy',
    'empire_statebuilding',
    'empty_box',
    'end_2',
    'end',
    'end2',
    'endways',
    'engineering',
    'envelope_2',
    'envelope',
    'environmental_2',
    'environmental_3',
    'environmental',
    'equalizer',
    'eraser_2',
    'eraser_3',
    'eraser',
    'error_404window',
    'euro_sign',
    'euro_sign2',
    'euro',
    'evernote',
    'evil',
    'explode',
    'eye_2',
    'eye_blind',
    'eye_invisible',
    'eye_scan',
    'eye_visible',
    'eye',
    'eyebrow_2',
    'eyebrow_3',
    'eyebrow',
    'eyeglasses_smiley',
    'eyeglasses_smiley2',
    'face_style',
    'face_style2',
    'face_style3',
    'face_style4',
    'face_style5',
    'face_style6',
    'facebook_2',
    'facebook',
    'factory_2',
    'factory',
    'fahrenheit',
    'family_sign',
    'fan',
    'farmer',
    'fashion',
    'favorite_window',
    'fax',
    'feather',
    'feedburner',
    'female_2',
    'female_sign',
    'female',
    'file_block',
    'file_bookmark',
    'file_chart',
    'file_clipboard',
    'file_clipboardfiletext',
    'file_clipboardtextimage',
    'file_cloud',
    'file_copy',
    'file_copy2',
    'file_csv',
    'file_download',
    'file_edit',
    'file_excel',
    'file_favorite',
    'file_fire',
    'file_graph',
    'file_hide',
    'file_horizontal',
    'file_horizontaltext',
    'file_html',
    'file_jpg',
    'file_link',
    'file_loading',
    'file_lock',
    'file_love',
    'file_music',
    'file_network',
    'file_pictures',
    'file_pie',
    'file_presentation',
    'file_refresh',
    'file_search',
    'file_settings',
    'file_share',
    'file_textimage',
    'file_trash',
    'file_txt',
    'file_upload',
    'file_video',
    'file_word',
    'file_zip',
    'file',
    'files',
    'film_board',
    'film_cartridge',
    'film_strip',
    'film_video',
    'film',
    'filter_2',
    'filter',
    'financial',
    'find_user',
    'finger_dragfoursides',
    'finger_dragtwosides',
    'finger_print',
    'finger',
    'fingerprint_2',
    'fingerprint',
    'fire_flame',
    'fire_flame2',
    'fire_hydrant',
    'fire_staion',
    'firefox',
    'firewall',
    'first_aid',
    'first',
    'fish_food',
    'fish',
    'fit_to',
    'fit_to2',
    'five_fingers',
    'five_fingersdrag',
    'five_fingersdrag2',
    'five_fingerstouch',
    'flag_2',
    'flag_3',
    'flag_4',
    'flag_5',
    'flag_6',
    'flag',
    'flamingo',
    'flash_2',
    'flash_video',
    'flash',
    'flashlight',
    'flask_2',
    'flask',
    'flick',
    'flickr',
    'flowerpot',
    'fluorescent',
    'fog_day',
    'fog_night',
    'folder_add',
    'folder_archive',
    'folder_binder',
    'folder_binder2',
    'folder_block',
    'folder_bookmark',
    'folder_close',
    'folder_cloud',
    'folder_delete',
    'folder_download',
    'folder_edit',
    'folder_favorite',
    'folder_fire',
    'folder_hide',
    'folder_link',
    'folder_loading',
    'folder_lock',
    'folder_love',
    'folder_music',
    'folder_network',
    'folder_open',
    'folder_open2',
    'folder_organizing',
    'folder_pictures',
    'folder_refresh',
    'folder_remove',
    'folder_search',
    'folder_settings',
    'folder_share',
    'folder_trash',
    'folder_upload',
    'folder_video',
    'folder_withdocument',
    'folder_zip',
    'folder',
    'folders',
    'font_color',
    'font_name',
    'font_size',
    'font_style',
    'font_stylesubscript',
    'font_stylesuperscript',
    'font_window',
    'foot_2',
    'foot',
    'football_2',
    'football',
    'footprint_2',
    'footprint_3',
    'footprint',
    'forest',
    'fork',
    'formspring',
    'formula',
    'forsquare',
    'forward',
    'fountain_pen',
    'four_fingers',
    'four_fingersdrag',
    'four_fingersdrag2',
    'four_fingerstouch',
    'fox',
    'frankenstein',
    'french_fries',
    'friendfeed',
    'friendster',
    'frog',
    'fruits',
    'fuel',
    'full_bag',
    'full_basket',
    'full_cart',
    'full_moon',
    'full_screen',
    'full_screen2',
    'full_view',
    'full_view2',
    'full_viewwindow',
    'function',
    'funky',
    'funny_bicycle',
    'furl',
    'gamepad_2',
    'gamepad',
    'gas_pump',
    'gaugage_2',
    'gaugage',
    'gay',
    'gear_2',
    'gear',
    'gears_2',
    'gears',
    'geek_2',
    'geek',
    'gemini_2',
    'gemini',
    'genius',
    'gentleman',
    'geo_',
    'geo_close',
    'geo_love',
    'geo_minus',
    'geo_number',
    'geo_star',
    'geo',
    'geo2_',
    'geo2_close',
    'geo2_love',
    'geo2_minus',
    'geo2_number',
    'geo2_star',
    'geo2',
    'geo3_',
    'geo3_close',
    'geo3_love',
    'geo3_minus',
    'geo3_number',
    'geo3_star',
    'geo3',
    'gey',
    'gift_box',
    'giraffe',
    'girl',
    'glass_water',
    'glasses_2',
    'glasses_3',
    'glasses',
    'global_position',
    'globe_2',
    'globe',
    'gloves',
    'go_bottom',
    'go_top',
    'goggles',
    'golf_2',
    'golf',
    'google_buzz',
    'google_drive',
    'google_play',
    'google_plus',
    'google',
    'gopro',
    'gorilla',
    'gowalla',
    'grave',
    'graveyard',
    'greece',
    'green_energy',
    'green_house',
    'guitar',
    'gun_2',
    'gun_3',
    'gun',
    'gymnastics',
    'hair_2',
    'hair_3',
    'hair_4',
    'hair',
    'half_moon',
    'halloween_halfmoon',
    'halloween_moon',
    'hamburger',
    'hammer',
    'hand_touch',
    'hand_touch2',
    'hand_touchsmartphone',
    'hand',
    'hands',
    'handshake',
    'hanger',
    'happy',
    'hat_2',
    'hat',
    'haunted_house',
    'hd_video',
    'hd',
    'hdd',
    'headphone',
    'headphones',
    'headset',
    'heart_2',
    'heart',
    'heels_2',
    'heels',
    'height_window',
    'helicopter_2',
    'helicopter',
    'helix_2',
    'hello',
    'helmet_2',
    'helmet_3',
    'helmet',
    'hipo',
    'hipster_glasses',
    'hipster_glasses2',
    'hipster_glasses3',
    'hipster_headphones',
    'hipster_men',
    'hipster_men2',
    'hipster_men3',
    'hipster_sunglasses',
    'hipster_sunglasses2',
    'hipster_sunglasses3',
    'hokey',
    'holly',
    'home_2',
    'home_3',
    'home_4',
    'home_5',
    'home_window',
    'home',
    'homosexual',
    'honey',
    'hong_kong',
    'hoodie',
    'horror',
    'horse',
    'hospital_2',
    'hospital',
    'host',
    'hot_dog',
    'hotel',
    'hour',
    'hub',
    'humor',
    'hurt',
    'ice_cream',
    'icq',
    'id_2',
    'id_3',
    'id_card',
    'idea_2',
    'idea_3',
    'idea_4',
    'idea_5',
    'idea',
    'identification_badge',
    'imdb',
    'inbox_empty',
    'inbox_forward',
    'inbox_full',
    'inbox_into',
    'inbox_out',
    'inbox_reply',
    'inbox',
    'increase_inedit',
    'indent_firstline',
    'indent_leftmargin',
    'indent_rightmargin',
    'india',
    'info_window',
    'information',
    'inifity',
    'instagram',
    'internet_2',
    'internet_explorer',
    'internet_smiley',
    'internet',
    'ios_apple',
    'israel',
    'italic_text',
    'jacket_2',
    'jacket',
    'jamaica',
    'japan',
    'japanese_gate',
    'jeans',
    'jeep_2',
    'jeep',
    'jet',
    'joystick',
    'juice',
    'jump_rope',
    'kangoroo',
    'kenya',
    'key_2',
    'key_3',
    'key_lock',
    'key',
    'keyboard',
    'keyboard3',
    'keypad',
    'king_2',
    'king',
    'kiss',
    'knee',
    'knife_2',
    'knife',
    'knight',
    'koala',
    'korea',
    'lamp',
    'landscape_2',
    'landscape',
    'lantern',
    'laptop_2',
    'laptop_3',
    'laptop_phone',
    'laptop_secure',
    'laptop_tablet',
    'laptop',
    'laser',
    'last_fm',
    'last',
    'laughing',
    'layer_1635',
    'layer_1646',
    'layer_backward',
    'layer_forward',
    'leafs_2',
    'leafs',
    'leaning_tower',
    'left__right',
    'left__right3',
    'left_2',
    'left_3',
    'left_4',
    'left_toright',
    'left',
    'leg_2',
    'leg',
    'lego',
    'lemon',
    'len_2',
    'len_3',
    'len',
    'leo_2',
    'leo',
    'leopard',
    'lesbian',
    'lesbians',
    'letter_close',
    'letter_open',
    'letter_sent',
    'libra_2',
    'libra',
    'library_2',
    'library',
    'life_jacket',
    'life_safer',
    'light_bulb',
    'light_bulb2',
    'light_bulbleaf',
    'lighthouse',
    'like_2',
    'like',
    'line_chart',
    'line_chart2',
    'line_chart3',
    'line_chart4',
    'line_spacing',
    'line_spacingtext',
    'link_2',
    'link',
    'linkedin_2',
    'linkedin',
    'linux',
    'lion',
    'livejournal',
    'loading_2',
    'loading_3',
    'loading_window',
    'loading',
    'location_2',
    'location',
    'lock_2',
    'lock_3',
    'lock_user',
    'lock_window',
    'lock',
    'lollipop_2',
    'lollipop_3',
    'lollipop',
    'loop',
    'loud',
    'loudspeaker',
    'love_2',
    'love_user',
    'love_window',
    'love',
    'lowercase_text',
    'luggafe_front',
    'luggage_2',
    'macro',
    'magic_wand',
    'magnet',
    'magnifi_glass_minus',
    'magnifi_glass',
    'magnifi_glass2',
    'mail_2',
    'mail_3',
    'mail_add',
    'mail_attachement',
    'mail_block',
    'mail_delete',
    'mail_favorite',
    'mail_forward',
    'mail_gallery',
    'mail_inbox',
    'mail_link',
    'mail_lock',
    'mail_love',
    'mail_money',
    'mail_open',
    'mail_outbox',
    'mail_password',
    'mail_photo',
    'mail_read',
    'mail_removex',
    'mail_reply',
    'mail_replyall',
    'mail_search',
    'mail_send',
    'mail_settings',
    'mail_unread',
    'mail_video',
    'mail_withatsign',
    'mail_withcursors',
    'mail',
    'mailbox_empty',
    'mailbox_full',
    'male_2',
    'male_sign',
    'male',
    'malefemale',
    'man_sign',
    'management',
    'mans_underwear',
    'mans_underwear2',
    'map_marker',
    'map_marker2',
    'map_marker3',
    'map',
    'map2',
    'marker_2',
    'marker_3',
    'marker',
    'martini_glass',
    'mask',
    'master_card',
    'maximize_window',
    'maximize',
    'medal_2',
    'medal_3',
    'medal',
    'medical_sign',
    'medicine_2',
    'medicine_3',
    'medicine',
    'megaphone',
    'memory_card',
    'memory_card2',
    'memory_card3',
    'men',
    'menorah',
    'mens',
    'metacafe',
    'mexico',
    'mic',
    'microphone_2',
    'microphone_3',
    'microphone_4',
    'microphone_5',
    'microphone_6',
    'microphone_7',
    'microphone',
    'microscope',
    'milk_bottle',
    'mine',
    'minimize_maximize_close_window',
    'minimize_window',
    'minimize',
    'mirror',
    'mixer',
    'mixx',
    'money_2',
    'money_bag',
    'money_smiley',
    'money',
    'monitor_2',
    'monitor_3',
    'monitor_4',
    'monitor_5',
    'monitor_analytics',
    'monitor_laptop',
    'monitor_phone',
    'monitor_tablet',
    'monitor_vertical',
    'monitor',
    'monitoring',
    'monkey',
    'monster',
    'morocco',
    'motorcycle',
    'mouse_2',
    'mouse_3',
    'mouse_4',
    'mouse_pointer',
    'mouse',
    'moustache_smiley',
    'movie_ticket',
    'movie',
    'mp3_file',
    'museum',
    'mushroom',
    'music_note',
    'music_note2',
    'music_note3',
    'music_note4',
    'music_player',
    'mustache_2',
    'mustache_3',
    'mustache_4',
    'mustache_5',
    'mustache_6',
    'mustache_7',
    'mustache_8',
    'mustache',
    'mute',
    'myspace',
    'navigat_start',
    'navigate_end',
    'navigation_leftwindow',
    'navigation_rightwindow',
    'nepal',
    'netscape',
    'network_window',
    'network',
    'neutron',
    'new_mail',
    'new_tab',
    'newspaper_2',
    'newspaper',
    'newsvine',
    'next_3',
    'next_music',
    'next',
    'next2',
    'no_battery',
    'no_drop',
    'no_flash',
    'no_smoking',
    'noose',
    'normal_text',
    'note',
    'notepad_2',
    'notepad',
    'nuclear',
    'numbering_list',
    'nurse',
    'office_lamp',
    'office',
    'oil',
    'old_camera',
    'old_cassette',
    'old_clock',
    'old_radio',
    'old_sticky',
    'old_sticky2',
    'old_telephone',
    'old_tv',
    'on_air',
    'on_off_2',
    'on_off_3',
    'on_off',
    'one_finger',
    'one_fingertouch',
    'one_window',
    'open_banana',
    'open_book',
    'opera_house',
    'opera',
    'optimization',
    'orientation_2',
    'orientation_3',
    'orientation',
    'orkut',
    'ornament',
    'over_time',
    'over_time2',
    'owl',
    'pac_man',
    'paint_brush',
    'paint_bucket',
    'paintbrush',
    'palette',
    'palm_tree',
    'panda',
    'panorama',
    'pantheon',
    'pantone',
    'pants',
    'paper_plane',
    'paper',
    'parasailing',
    'parrot',
    'password_2shopping',
    'password_field',
    'password_shopping',
    'password',
    'pause_2',
    'pause',
    'paw',
    'pawn',
    'paypal',
    'pen_2',
    'pen_3',
    'pen_4',
    'pen_5',
    'pen_6',
    'pen',
    'pencil_ruler',
    'pencil',
    'penguin',
    'pentagon',
    'people_oncloud',
    'pepper_withfire',
    'pepper',
    'petrol',
    'petronas_tower',
    'philipines',
    'phone_2',
    'phone_3',
    'phone_3g',
    'phone_4g',
    'phone_simcard',
    'phone_sms',
    'phone_wifi',
    'phone',
    'photo_2',
    'photo_3',
    'photo_album',
    'photo_album2',
    'photo_album3',
    'photo',
    'photos',
    'physics',
    'pi',
    'piano',
    'picasa',
    'pie_chart',
    'pie_chart2',
    'pie_chart3',
    'pilates_2',
    'pilates_3',
    'pilates',
    'pilot',
    'pinch',
    'ping_pong',
    'pinterest',
    'pipe',
    'pipette',
    'piramids',
    'pisces_2',
    'pisces',
    'pizza_slice',
    'pizza',
    'plane_2',
    'plane',
    'plant',
    'plasmid',
    'plaster',
    'plastic_cupphone',
    'plastic_cupphone2',
    'plate',
    'plates',
    'plaxo',
    'play_music',
    'plug_in',
    'plug_in2',
    'plurk',
    'pointer',
    'poland',
    'police_man',
    'police_station',
    'police_woman',
    'police',
    'polo_shirt',
    'portrait',
    'portugal',
    'post_mail',
    'post_mail2',
    'post_office',
    'post_sign',
    'post_sign2ways',
    'posterous',
    'pound_sign',
    'pound_sign2',
    'pound',
    'power_2',
    'power_3',
    'power_cable',
    'power_station',
    'power',
    'prater',
    'present',
    'presents',
    'press',
    'preview',
    'previous',
    'pricing',
    'printer',
    'professor',
    'profile',
    'project',
    'projector_2',
    'projector',
    'pulse',
    'pumpkin',
    'punk',
    'punker',
    'puzzle',
    'qik',
    'qr_code',
    'queen_2',
    'queen',
    'quill_2',
    'quill_3',
    'quill',
    'quotes_2',
    'quotes',
    'radio',
    'radioactive',
    'rafting',
    'rain_drop',
    'rainbow_2',
    'rainbow',
    'ram',
    'razzor_blade',
    'receipt_2',
    'receipt_3',
    'receipt_4',
    'receipt',
    'record_3',
    'record_music',
    'record',
    'record2',
    'recycling_2',
    'recycling',
    'reddit',
    'redhat',
    'redirect',
    'redo',
    'reel',
    'refinery',
    'refresh_window',
    'refresh',
    'reload_2',
    'reload_3',
    'reload',
    'remote_controll',
    'remote_controll2',
    'remove_bag',
    'remove_basket',
    'remove_cart',
    'remove_file',
    'remove_user',
    'remove_window',
    'remove',
    'rename',
    'repair',
    'repeat_2',
    'repeat_3',
    'repeat_4',
    'repeat_5',
    'repeat_6',
    'repeat_7',
    'repeat',
    'reset',
    'resize',
    'restore_window',
    'retouching',
    'retro_camera',
    'retro',
    'retweet',
    'reverbnation',
    'rewind',
    'rgb',
    'ribbon_2',
    'ribbon_3',
    'ribbon',
    'right_2',
    'right_3',
    'right_4',
    'right_toleft',
    'right',
    'road_2',
    'road_3',
    'road',
    'robot_2',
    'robot',
    'rock_androll',
    'rocket',
    'roller',
    'roof',
    'rook',
    'rotate_gesture',
    'rotate_gesture2',
    'rotate_gesture3',
    'rotation_390',
    'rotation',
    'router_2',
    'router',
    'rss',
    'ruler_2',
    'ruler',
    'running_shoes',
    'running',
    'safari',
    'safe_box',
    'safe_box2',
    'safety_pinclose',
    'safety_pinopen',
    'sagittarus_2',
    'sagittarus',
    'sailing_ship',
    'sand_watch',
    'sand_watch2',
    'santa_claus',
    'santa_claus2',
    'santa_onsled',
    'satelite_2',
    'satelite',
    'save_window',
    'save',
    'saw',
    'saxophone',
    'scale',
    'scarf',
    'scissor',
    'scooter_front',
    'scooter',
    'scorpio_2',
    'scorpio',
    'scotland',
    'screwdriver',
    'scroll_fast',
    'scroll',
    'scroller_2',
    'scroller',
    'sea_dog',
    'search_oncloud',
    'search_people',
    'secound',
    'secound2',
    'security_block',
    'security_bug',
    'security_camera',
    'security_check',
    'security_settings',
    'security_smiley',
    'securiy_remove',
    'seed',
    'selfie',
    'serbia',
    'server_2',
    'server',
    'servers',
    'settings_window',
    'sewing_machine',
    'sexual',
    'share_oncloud',
    'share_window',
    'share',
    'sharethis',
    'shark',
    'sheep',
    'sheriff_badge',
    'shield',
    'ship_2',
    'ship',
    'shirt',
    'shoes_2',
    'shoes_3',
    'shoes',
    'shop_2',
    'shop_3',
    'shop_4',
    'shop',
    'shopping_bag',
    'shopping_basket',
    'shopping_cart',
    'short_pants',
    'shoutwire',
    'shovel',
    'shuffle_2',
    'shuffle_3',
    'shuffle_4',
    'shuffle',
    'shutter',
    'sidebar_window',
    'signal',
    'singapore',
    'skate_shoes',
    'skateboard_2',
    'skateboard',
    'skeleton',
    'ski',
    'skirt',
    'skrill',
    'skull',
    'skydiving',
    'skype',
    'sled_withgifts',
    'sled',
    'sleeping',
    'sleet',
    'slippers',
    'smart',
    'smartphone_2',
    'smartphone_3',
    'smartphone_4',
    'smartphone_secure',
    'smartphone',
    'smile',
    'smoking_area',
    'smoking_pipe',
    'snake',
    'snorkel',
    'snow_2',
    'snow_dome',
    'snow_storm',
    'snow',
    'snowflake_2',
    'snowflake_3',
    'snowflake_4',
    'snowflake',
    'snowman',
    'soccer_ball',
    'soccer_shoes',
    'socks',
    'solar',
    'sound_wave',
    'sound',
    'soundcloud',
    'soup',
    'south_africa',
    'space_needle',
    'spain',
    'spam_mail',
    'speach_bubble',
    'speach_bubble2',
    'speach_bubble3',
    'speach_bubble4',
    'speach_bubble5',
    'speach_bubble6',
    'speach_bubble7',
    'speach_bubble8',
    'speach_bubble9',
    'speach_bubble10',
    'speach_bubble11',
    'speach_bubble12',
    'speach_bubble13',
    'speach_bubbleasking',
    'speach_bubblecomic',
    'speach_bubblecomic2',
    'speach_bubblecomic3',
    'speach_bubblecomic4',
    'speach_bubbledialog',
    'speach_bubbles',
    'speak_2',
    'speak',
    'speaker_2',
    'speaker',
    'spell_check',
    'spell_checkabc',
    'spermium',
    'spider',
    'spiderweb',
    'split_foursquarewindow',
    'split_horizontal',
    'split_horizontal2window',
    'split_vertical',
    'split_vertical2',
    'split_window',
    'spoder',
    'spoon',
    'sport_mode',
    'sports_clothings1',
    'sports_clothings2',
    'sports_shirt',
    'spot',
    'spray',
    'spread',
    'spring',
    'spurl',
    'spy',
    'squirrel',
    'ssl',
    'st_basilscathedral',
    'st_paulscathedral',
    'stamp_2',
    'stamp',
    'stapler',
    'star_track',
    'star',
    'starfish',
    'start_3',
    'start_ways',
    'start',
    'start2',
    'statistic',
    'stethoscope',
    'stop__2',
    'stop_music',
    'stop',
    'stopwatch_2',
    'stopwatch',
    'storm',
    'street_view',
    'street_view2',
    'strikethrough_text',
    'stroller',
    'structure',
    'student_female',
    'student_hat',
    'student_hat2',
    'student_male',
    'student_malefemale',
    'students',
    'studio_flash',
    'studio_lightbox',
    'stumbleupon',
    'suit',
    'suitcase',
    'sum_2',
    'sum',
    'summer',
    'sun_cloudyrain',
    'sun',
    'sunglasses_2',
    'sunglasses_3',
    'sunglasses_smiley',
    'sunglasses_smiley2',
    'sunglasses_w',
    'sunglasses_w2',
    'sunglasses_w3',
    'sunglasses',
    'sunrise',
    'sunset',
    'superman',
    'support',
    'surprise',
    'sushi',
    'sweden',
    'swimming_short',
    'swimming',
    'swimmwear',
    'switch',
    'switzerland',
    'sync_cloud',
    'sync',
    'synchronize_2',
    'synchronize',
    't_shirt',
    'tablet_2',
    'tablet_3',
    'tablet_orientation',
    'tablet_phone',
    'tablet_secure',
    'tablet_vertical',
    'tablet',
    'tactic',
    'tag_2',
    'tag_3',
    'tag_4',
    'tag_5',
    'tag',
    'taj_mahal',
    'talk_man',
    'tap',
    'target_market',
    'target',
    'taurus_2',
    'taurus',
    'taxi_2',
    'taxi_sign',
    'taxi',
    'teacher',
    'teapot',
    'technorati',
    'teddy_bear',
    'tee_mug',
    'telephone_2',
    'telephone',
    'telescope',
    'temperature_2',
    'temperature_3',
    'temperature',
    'temple',
    'tennis_ball',
    'tennis',
    'tent',
    'test_tube',
    'test_tube2',
    'testimonal',
    'text_box',
    'text_effect',
    'text_highlightcolor',
    'text_paragraph',
    'thailand',
    'the_whitehouse',
    'this_sideup',
    'thread',
    'three_arrowfork',
    'three_fingers',
    'three_fingersdrag',
    'three_fingersdrag2',
    'three_fingerstouch',
    'thumb',
    'thumbs_downsmiley',
    'thumbs_upsmiley',
    'thunder',
    'thunderstorm',
    'ticket',
    'tie_2',
    'tie_3',
    'tie_4',
    'tie',
    'tiger',
    'time_backup',
    'time_bomb',
    'time_clock',
    'time_fire',
    'time_machine',
    'time_window',
    'timer_2',
    'timer',
    'to_bottom',
    'to_bottom2',
    'to_left',
    'to_right',
    'to_top',
    'to_top2',
    'token_',
    'tomato',
    'tongue',
    'tooth_2',
    'tooth',
    'top_tobottom',
    'touch_window',
    'tourch',
    'tower_2',
    'tower_bridge',
    'tower',
    'trace',
    'tractor',
    'traffic_light',
    'traffic_light2',
    'train_2',
    'train',
    'tram',
    'transform_2',
    'transform_3',
    'transform_4',
    'transform',
    'trash_withmen',
    'tree_2',
    'tree_3',
    'tree_4',
    'tree_5',
    'tree',
    'trekking',
    'triangle_arrowdown',
    'triangle_arrowleft',
    'triangle_arrowright',
    'triangle_arrowup',
    'tripod_2',
    'tripod_andvideo',
    'tripod_withcamera',
    'tripod_withgopro',
    'trophy_2',
    'trophy',
    'truck',
    'trumpet',
    'tumblr',
    'turkey',
    'turn_down',
    'turn_down2',
    'turn_downfromleft',
    'turn_downfromright',
    'turn_left',
    'turn_left3',
    'turn_right',
    'turn_right3',
    'turn_up',
    'turn_up2',
    'turtle',
    'tuxedo',
    'tv',
    'twister',
    'twitter_2',
    'twitter',
    'two_fingers',
    'two_fingersdrag',
    'two_fingersdrag2',
    'two_fingersscroll',
    'two_fingerstouch',
    'two_windows',
    'type_pass',
    'ukraine',
    'umbrela',
    'umbrella_2',
    'umbrella_3',
    'under_linetext',
    'undo',
    'united_kingdom',
    'united_states',
    'university_2',
    'university',
    'unlike_2',
    'unlike',
    'unlock_2',
    'unlock_3',
    'unlock',
    'up__down',
    'up__down3',
    'up_2',
    'up_3',
    'up_4',
    'up',
    'upgrade',
    'upload_2',
    'upload_tocloud',
    'upload_window',
    'upload',
    'uppercase_text',
    'upward',
    'url_window',
    'usb_2',
    'usb_cable',
    'usb',
    'user',
    'ustream',
    'vase',
    'vector_2',
    'vector_3',
    'vector_4',
    'vector_5',
    'vector',
    'venn_diagram',
    'vest_2',
    'vest',
    'viddler',
    'video_2',
    'video_3',
    'video_4',
    'video_5',
    'video_6',
    'video_gamecontroller',
    'video_len',
    'video_len2',
    'video_photographer',
    'video_tripod',
    'video',
    'vietnam',
    'view_height',
    'view_width',
    'vimeo',
    'virgo_2',
    'virgo',
    'virus_2',
    'virus_3',
    'virus',
    'visa',
    'voice',
    'voicemail',
    'volleyball',
    'volume_down',
    'volume_up',
    'vpn',
    'wacom_tablet',
    'waiter',
    'walkie_talkie',
    'wallet_2',
    'wallet_3',
    'wallet',
    'warehouse',
    'warning_window',
    'watch_2',
    'watch_3',
    'watch',
    'wave_2',
    'wave',
    'webcam',
    'weight_lift',
    'wheelbarrow',
    'wheelchair',
    'width_window',
    'wifi_2',
    'wifi_keyboard',
    'wifi',
    'wind_turbine',
    'windmill',
    'window_2',
    'window',
    'windows_2',
    'windows_microsoft',
    'windows',
    'windsock',
    'windy',
    'wine_bottle',
    'wine_glass',
    'wink',
    'winter_2',
    'winter',
    'wireless',
    'witch_hat',
    'witch',
    'wizard',
    'wolf',
    'woman_sign',
    'womanman',
    'womans_underwear',
    'womans_underwear2',
    'women',
    'wonder_woman',
    'wordpress',
    'worker_clothes',
    'worker',
    'wrap_text',
    'wreath',
    'wrench',
    'x_box',
    'x_ray',
    'xanga',
    'xing',
    'yacht',
    'yahoo_buzz',
    'yahoo',
    'yelp',
    'yes',
    'ying_yang',
    'youtube',
    'z_a',
    'zebra',
    'zombie',
    'zoom_gesture',
    'zootool'
];
export const dripicons = [
    'alarm',
    'align-center',
    'align-justify',
    'align-left',
    'align-right',
    'anchor',
    'archive',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-thin-down',
    'arrow-thin-left',
    'arrow-thin-right',
    'arrow-thin-up',
    'arrow-up',
    'article',
    'backspace',
    'basket',
    'basketball',
    'battery-empty',
    'battery-full',
    'battery-low',
    'battery-medium',
    'bell',
    'blog',
    'bluetooth',
    'bold',
    'bookmark',
    'bookmarks',
    'box',
    'briefcase',
    'brightness-low',
    'brightness-max',
    'brightness-medium',
    'broadcast',
    'browser-upload',
    'browser',
    'brush',
    'calendar',
    'camcorder',
    'camera',
    'card',
    'cart',
    'checklist',
    'checkmark',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'clipboard',
    'clock',
    'clockwise',
    'cloud-download',
    'cloud-upload',
    'cloud',
    'code',
    'contract-2',
    'contract',
    'conversation',
    'copy',
    'crop',
    'cross',
    'crosshair',
    'cutlery',
    'device-desktop',
    'device-mobile',
    'device-tablet',
    'direction',
    'disc',
    'document-delete',
    'document-edit',
    'document-new',
    'document-remove',
    'document',
    'dot',
    'dots-2',
    'dots-3',
    'download',
    'duplicate',
    'enter',
    'exit',
    'expand-2',
    'expand',
    'experiment',
    'export',
    'feed',
    'flag',
    'flashlight',
    'folder-open',
    'folder',
    'forward',
    'gaming',
    'gear',
    'graduation',
    'graph-bar',
    'graph-line',
    'graph-pie',
    'headset',
    'heart',
    'help',
    'home',
    'hourglass',
    'inbox',
    'information',
    'italic',
    'jewel',
    'lifting',
    'lightbulb',
    'link-broken',
    'link',
    'list',
    'loading',
    'location',
    'lock-open',
    'lock',
    'mail',
    'map',
    'media-loop',
    'media-next',
    'media-pause',
    'media-play',
    'media-previous',
    'media-record',
    'media-shuffle',
    'media-stop',
    'medical',
    'menu',
    'message',
    'meter',
    'microphone',
    'minus',
    'monitor',
    'move',
    'music',
    'network-1',
    'network-2',
    'network-3',
    'network-4',
    'network-5',
    'pamphlet',
    'paperclip',
    'pencil',
    'phone',
    'photo-group',
    'photo',
    'pill',
    'pin',
    'plus',
    'power',
    'preview',
    'print',
    'pulse',
    'question',
    'reply-all',
    'reply',
    'return',
    'retweet',
    'rocket',
    'scale',
    'search',
    'shopping-bag',
    'skip',
    'stack',
    'star',
    'stopwatch',
    'store',
    'suitcase',
    'swap',
    'tag-delete',
    'tag',
    'tags',
    'thumbs-down',
    'thumbs-up',
    'ticket',
    'time-reverse',
    'to-do',
    'toggles',
    'trash',
    'trophy',
    'upload',
    'user-group',
    'user-id',
    'user',
    'vibrate',
    'view-apps',
    'view-list-large',
    'view-list',
    'view-thumb',
    'volume-full',
    'volume-low',
    'volume-medium',
    'volume-off',
    'wallet',
    'warning',
    'web',
    'weight',
    'wifi',
    'wrong',
    'zoom-in',
    'zoom-out'
];
export const feather = [
    'activity',
    'airplay',
    'alert-circle',
    'alert-octagon',
    'alert-triangle',
    'align-center',
    'align-justify',
    'align-left',
    'align-right',
    'anchor',
    'aperture',
    'archive',
    'arrow-down-circle',
    'arrow-down-left',
    'arrow-down-right',
    'arrow-down',
    'arrow-left-circle',
    'arrow-left',
    'arrow-right-circle',
    'arrow-right',
    'arrow-up-circle',
    'arrow-up-left',
    'arrow-up-right',
    'arrow-up',
    'at-sign',
    'award',
    'bar-chart-2',
    'bar-chart',
    'battery-charging',
    'battery',
    'bell-off',
    'bell',
    'bluetooth',
    'bold',
    'book-open',
    'book',
    'bookmark',
    'box',
    'briefcase',
    'calendar',
    'camera-off',
    'camera',
    'cast',
    'check-circle',
    'check-square',
    'check',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'chevrons-down',
    'chevrons-left',
    'chevrons-right',
    'chevrons-up',
    'chrome',
    'circle',
    'clipboard',
    'clock',
    'cloud-drizzle',
    'cloud-lightning',
    'cloud-off',
    'cloud-rain',
    'cloud-snow',
    'cloud',
    'code',
    'codepen',
    'codesandbox',
    'coffee',
    'columns',
    'command',
    'compass',
    'copy',
    'corner-down-left',
    'corner-down-right',
    'corner-left-down',
    'corner-left-up',
    'corner-right-down',
    'corner-right-up',
    'corner-up-left',
    'corner-up-right',
    'cpu',
    'credit-card',
    'crop',
    'crosshair',
    'database',
    'delete',
    'disc',
    'dollar-sign',
    'download-cloud',
    'download',
    'droplet',
    'edit-2',
    'edit-3',
    'edit',
    'external-link',
    'eye-off',
    'eye',
    'facebook',
    'fast-forward',
    'feather',
    'figma',
    'file-minus',
    'file-plus',
    'file-text',
    'file',
    'film',
    'filter',
    'flag',
    'folder-minus',
    'folder-plus',
    'folder',
    'framer',
    'frown',
    'gift',
    'git-branch',
    'git-commit',
    'git-merge',
    'git-pull-request',
    'github',
    'gitlab',
    'globe',
    'grid',
    'hard-drive',
    'hash',
    'headphones',
    'heart',
    'help-circle',
    'hexagon',
    'home',
    'image',
    'inbox',
    'info',
    'instagram',
    'italic',
    'key',
    'layers',
    'layout',
    'life-buoy',
    'link-2',
    'link',
    'linkedin',
    'list',
    'loader',
    'lock',
    'log-in',
    'log-out',
    'mail',
    'map-pin',
    'map',
    'maximize-2',
    'maximize',
    'meh',
    'menu',
    'message-circle',
    'message-square',
    'mic-off',
    'mic',
    'minimize-2',
    'minimize',
    'minus-circle',
    'minus-square',
    'minus',
    'monitor',
    'moon',
    'more-horizontal',
    'more-vertical',
    'mouse-pointer',
    'move',
    'music',
    'navigation-2',
    'navigation',
    'octagon',
    'package',
    'paperclip',
    'pause-circle',
    'pause',
    'pen-tool',
    'percent',
    'phone-call',
    'phone-forwarded',
    'phone-incoming',
    'phone-missed',
    'phone-off',
    'phone-outgoing',
    'phone',
    'pie-chart',
    'play-circle',
    'play',
    'plus-circle',
    'plus-square',
    'plus',
    'pocket',
    'power',
    'printer',
    'radio',
    'refresh-ccw',
    'refresh-cw',
    'repeat',
    'rewind',
    'rotate-ccw',
    'rotate-cw',
    'rss',
    'save',
    'scissors',
    'search',
    'send',
    'server',
    'settings',
    'share-2',
    'share',
    'shield-off',
    'shield',
    'shopping-bag',
    'shopping-cart',
    'shuffle',
    'sidebar',
    'skip-back',
    'skip-forward',
    'slack',
    'slash',
    'sliders',
    'smartphone',
    'smile',
    'speaker',
    'square',
    'star',
    'stop-circle',
    'sun',
    'sunrise',
    'sunset',
    'tablet',
    'tag',
    'target',
    'terminal',
    'thermometer',
    'thumbs-down',
    'thumbs-up',
    'toggle-left',
    'toggle-right',
    'tool',
    'trash-2',
    'trash',
    'trello',
    'trending-down',
    'trending-up',
    'triangle',
    'truck',
    'tv',
    'twitch',
    'twitter',
    'type',
    'umbrella',
    'underline',
    'unlock',
    'upload-cloud',
    'upload',
    'user-check',
    'user-minus',
    'user-plus',
    'user-x',
    'user',
    'users',
    'video-off',
    'video',
    'voicemail',
    'volume-1',
    'volume-2',
    'volume-x',
    'volume',
    'watch',
    'wifi-off',
    'wifi',
    'wind',
    'x-circle',
    'x-octagon',
    'x-square',
    'x',
    'youtube',
    'zap-off',
    'zap',
    'zoom-in',
    'zoom-out'
];
export const heroicons = [
    'academic-cap',
    'adjustments',
    'archive',
    'annotation',
    'arrow-circle-down',
    'arrow-circle-left',
    'arrow-circle-right',
    'arrow-circle-up',
    'arrow-down',
    'arrow-left',
    'arrow-narrow-down',
    'arrow-narrow-left',
    'arrow-narrow-right',
    'arrow-narrow-up',
    'arrow-right',
    'arrow-up',
    'arrows-expand',
    'at-symbol',
    'backspace',
    'badge-check',
    'ban',
    'beaker',
    'book-open',
    'bell',
    'bookmark-alt',
    'bookmark',
    'briefcase',
    'cake',
    'camera',
    'calculator',
    'cash',
    'chart-bar',
    'calendar',
    'chart-pie',
    'chart-square-bar',
    'chat-alt-2',
    'chat-alt',
    'chat',
    'check-circle',
    'check',
    'chevron-double-down',
    'chevron-double-left',
    'chevron-double-right',
    'chevron-double-up',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'clipboard-check',
    'chip',
    'clipboard-copy',
    'clipboard-list',
    'clipboard',
    'clock',
    'cloud-upload',
    'cloud-download',
    'cloud',
    'code',
    'cog',
    'collection',
    'color-swatch',
    'credit-card',
    'cube-transparent',
    'cube',
    'currency-bangladeshi',
    'currency-euro',
    'currency-dollar',
    'currency-pound',
    'currency-rupee',
    'currency-yen',
    'cursor-click',
    'database',
    'desktop-computer',
    'device-mobile',
    'document-add',
    'device-tablet',
    'document-download',
    'document-duplicate',
    'document-report',
    'document-remove',
    'document-search',
    'document-text',
    'document',
    'dots-circle-horizontal',
    'dots-horizontal',
    'dots-vertical',
    'download',
    'duplicate',
    'emoji-happy',
    'emoji-sad',
    'exclamation-circle',
    'exclamation',
    'external-link',
    'eye-off',
    'eye',
    'fast-forward',
    'film',
    'filter',
    'finger-print',
    'fire',
    'flag',
    'folder-add',
    'folder-download',
    'folder-open',
    'folder-remove',
    'folder',
    'gift',
    'globe-alt',
    'globe',
    'hand',
    'hashtag',
    'heart',
    'home',
    'identification',
    'inbox-in',
    'inbox',
    'information-circle',
    'key',
    'library',
    'light-bulb',
    'lightning-bolt',
    'link',
    'location-marker',
    'lock-closed',
    'lock-open',
    'login',
    'logout',
    'mail-open',
    'mail',
    'map',
    'menu-alt-1',
    'menu-alt-2',
    'menu-alt-3',
    'menu-alt-4',
    'menu',
    'microphone',
    'minus-circle',
    'moon',
    'music-note',
    'minus',
    'newspaper',
    'office-building',
    'paper-airplane',
    'paper-clip',
    'pause',
    'pencil-alt',
    'pencil',
    'phone-incoming',
    'phone-missed-call',
    'phone-outgoing',
    'photograph',
    'phone',
    'play',
    'plus-circle',
    'plus',
    'presentation-chart-bar',
    'presentation-chart-line',
    'printer',
    'puzzle',
    'qrcode',
    'question-mark-circle',
    'receipt-refund',
    'receipt-tax',
    'refresh',
    'reply',
    'rewind',
    'rss',
    'save-as',
    'save',
    'scale',
    'scissors',
    'search-circle',
    'search',
    'selector',
    'server',
    'share',
    'shield-check',
    'shield-exclamation',
    'shopping-bag',
    'shopping-cart',
    'sort-ascending',
    'sort-descending',
    'sparkles',
    'speakerphone',
    'star',
    'status-offline',
    'status-online',
    'stop',
    'sun',
    'support',
    'switch-horizontal',
    'switch-vertical',
    'table',
    'tag',
    'template',
    'terminal',
    'thumb-down',
    'thumb-up',
    'ticket',
    'translate',
    'trash',
    'trending-down',
    'trending-up',
    'truck',
    'upload',
    'user-add',
    'user-circle',
    'user-group',
    'user-remove',
    'user',
    'users',
    'variable',
    'video-camera',
    'view-boards',
    'view-grid-add',
    'view-grid',
    'view-list',
    'volume-off',
    'volume-up',
    'wifi',
    'x-circle',
    'x',
    'zoom-in',
    'zoom-out'
];
